import { IconDescriptionSlider } from '../../../js/src/__utils/sliders';

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		IconDescriptionSlider.init();
	},
	loaded() {},
	resized() {
		IconDescriptionSlider.resized();
	},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
